import { businessKey } from 'queryKeys';

const HOURLY_TRACKER = 'hourly-tracker';
const DRILL_TO = 'drillTo';
const DIMENSIONS = 'dimensions';
const FILTER_DETAILS = 'filterDetails';

export const htQuery = businessKey.query(HOURLY_TRACKER);
export const filterDetails = businessKey.exact(FILTER_DETAILS);

export const grid = htQuery.grid();

export const charts = htQuery.charts();
export const getChartByIndex = (index) => (params) => [
  ...charts(),
  index,
  params,
];

const metricsQuery = htQuery.query('metrics');
export const columns = () => metricsQuery.all();
export const chartMetrics = metricsQuery.exact('chart');

export const dimensions = htQuery.exact(DIMENSIONS);

export const drillTo = htQuery.exact(DRILL_TO);
